import { ICaseAssertionModel, ICaseModel } from '../../../interfaces/ICase';

import CaseHelper from '../../../utilities/CaseHelper';
import { IAssertionDescriptorModel } from '../../../interfaces/IAssertionDescriptor';
import { IValidation } from '../../../interfaces/IError';
import { Modal } from 'react-bootstrap';
import { ReactNode } from 'react';

export interface IAdditionalFieldsDialogProps {
    assertionDescriptors: IAssertionDescriptorModel[];
    currentCase: ICaseModel;
    getSingleValueEditControl: (caseAssertion: ICaseAssertionModel) => ReactNode;
    onCancelClick: () => void;
    onHide: () => void;
    onOkClick: () => void;
    open: boolean;
    validation: IValidation;
}

export function AdditionalFieldsDialog(props: IAdditionalFieldsDialogProps) {
    return (
        <Modal centered show={props.open} backdrop>
            <Modal.Header>
                <Modal.Title>Enter Additional Data</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <BodyComponent {...props} />
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-black" onClick={props.onOkClick}>
                    OK
                </button>
                <button className="btn btn-default" onClick={props.onCancelClick}>
                    Cancel
                </button>
            </Modal.Footer>
        </Modal>
    );
}

function BodyComponent(props: IAdditionalFieldsDialogProps) {
    return (
        <>
            <div>
                <span className="text-danger">{props.validation.AdditionalDates}</span>
            </div>
            {CaseHelper.getAdditionalCaseAssertionFields(
                props.currentCase,
                props.assertionDescriptors
            ).map((caseAssertion: ICaseAssertionModel) => {
                const foundAD = props.assertionDescriptors.find(
                    (ad) => ad.guid === caseAssertion.assertionDescriptorGuid
                );
                return (
                    <div className="row mb-2" key={caseAssertion.assertionDescriptorGuid}>
                        <div className="col-sm-6">
                            <label>{foundAD?.displayName ?? 'Unknown'}</label>
                        </div>
                        <div className="col-sm-6">
                            {props.getSingleValueEditControl(caseAssertion)}
                        </div>
                    </div>
                );
            })}
        </>
    );
}
